import { render, staticRenderFns } from "./newDetails.vue?vue&type=template&id=c9945c20&scoped=true&"
import script from "./newDetails.vue?vue&type=script&lang=js&"
export * from "./newDetails.vue?vue&type=script&lang=js&"
import style0 from "./newDetails.vue?vue&type=style&index=0&id=c9945c20&scoped=true&lang=less&"
import style1 from "./newDetails.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9945c20",
  null
  
)

export default component.exports